<template>
  <View direction="column" gap="md" v-if="hasRenters">
    <template v-for="renterGroup in renterGroups" :key="renterGroup.id">
      <ShowingRentersListItem
        v-for="renter in renterGroup.renters"
        :key="renter.id"
        :renter="renter"
        :property-id="propertyId"
        :status="renterGroup.status"
      />
    </template>
  </View>
</template>

<script setup lang="ts">
import { computed, useId } from 'vue';

import { AvatarStatus, View } from '@tallo/design-system';
import { RenterDto } from '@tallo/renter';

import { ShowingDto } from '../interfaces/showing.interface';
import { getAcceptedRenters } from '../utils/get-accepted-renters.util';
import { getCanceledRenters } from '../utils/get-canceled-renters.util';
import { getDeclinedRenters } from '../utils/get-declined-renters.util';
import { getExpiredRenters } from '../utils/get-expired-renters.util';
import { getReschedulingRenters } from '../utils/get-rescheduling-renters.util';
import ShowingRentersListItem from './showing-renters-list-item.vue';

interface RenterGroup {
  id: string;
  status: AvatarStatus;
  renters: RenterDto[];
}

const props = defineProps<{ showing: ShowingDto }>();
const propertyId = computed(() => props.showing.property.id);
const renterGroups = computed<RenterGroup[]>(() => [
  {
    id: useId(),
    status: 'accepted',
    renters: getAcceptedRenters(props.showing),
  },
  {
    id: useId(),
    status: 'pending',
    renters: getReschedulingRenters(props.showing),
  },
  {
    id: useId(),
    status: 'declined',
    renters: getDeclinedRenters(props.showing),
  },
  {
    id: useId(),
    status: 'declined',
    renters: getCanceledRenters(props.showing),
  },
  {
    id: useId(),
    status: 'declined',
    renters: getExpiredRenters(props.showing),
  },
]);

const hasRenters = computed(() => renterGroups.value.some((group) => group.renters.length > 0));
</script>
